import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  name: string;
};

export const useSchemaReport = (projectData: ProjectDto) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.project' });
  const existingReports = projectData.reports.map((report) => report.name.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingReports, t('existing'))
          .max(250),
      }),
    [t, existingReports],
  );
};
